module.exports = __webpack_public_path__ + "media/images/p-about/partner/福知山市-994181a2593e5eedc8e944ea726980b2.png";